/**
 * Created by chengpanwang on 2017/3/23.
 */
import store from 'store'
var Store = {
  install (Vue) {
    Vue.prototype.$store = store
  },
}

export default Store



// WEBPACK FOOTER //
// ./src/plugins/Store.js